<template>
    <div class="tile-content" v-fs-block>
        <v-repeater
            :params="{
                limit: 6,
                offset: 0,
            }"
            :provider="provider"
            :map-rows="repeaterRows"
            :pagination="true"
            table-class="table-v-alignment-bottom fs-block"
        >
            <template slot="headers">
                <slot name="headers">
                    <th>Invoice<br/>Number</th>
                    <th>Products</th>
                    <th>Amount</th>
                    <th>Date Issued</th>
                    <th>Status</th>
                </slot>
            </template>
            <template slot="iteratee" slot-scope="{item}">
                <slot name="iteratee" :item="item">
                    <td v-fs-block>
                        <router-link :to="{name: 'invoice-details', params: {id: item.id}}">
                            {{item.invoiceNumberLabel}}
                        </router-link>
                    </td>
                    <td v-fs-block>{{item.productNames | join | coverEmpty}}</td>
                    <td v-fs-block>{{item.amount | monetizeExplicit(item.currency)}}</td>
                    <td v-fs-block>{{item.issuedTime | dateUTC('shortDate')}}</td>
                    <td v-fs-block>
                        <r-badge :type="getBadgeType('invoiceStatus', item.status)">
                            {{item.statusLabel}}
                        </r-badge>
                    </td>
                </slot>
            </template>
            <template slot="no-content">
                <slot name="no-content">
                    <p class="text-center text-muted">It seems that there are no invoices</p>
                </slot>
            </template>
        </v-repeater>
    </div>
</template>

<script>
    import {vIcon, vIconButton} from '@/components/form/index';
    import vRepeater from '@/components/repeater/repeater';
    import {getBadgeType} from '@/data/badges-color-map';
    import InvoiceModel from '@/common/models/invoice-model';

    export default {
        components: {
            vIcon,
            vIconButton,
            vRepeater,
        },
        props: {
            invoicesParams: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                isLoading: false,
            };
        },
        methods: {
            getBadgeType,
            async provider(params) {
                return this.$api(({invoices}) => invoices.getAll({...this.invoicesParams, ...params}));
            },
            repeaterRows(items) {
                return items.map(item => new InvoiceModel(item.fields));
            },
        },
    };
</script>
